// TO DO: remove once managed user and week one user are supported
import SignupModule from "@/components/signup/bxp-ui-signup/src";
import { useCohort } from "@/components/user-context";

import { LoggedInDevAIFreeExistingSitesUser } from "./existing-sites-user";
import { LoggedInDevAIFreeNewUser } from "./new-user";

export const LoggedInDevAIFree = () => {
    const cohort = useCohort();

    if (cohort === "new-user") {
        return <LoggedInDevAIFreeNewUser />;
    }

    if (cohort === "existing-user") {
        return <LoggedInDevAIFreeExistingSitesUser />;
    }

    if (cohort) {
        return <SignupModule bundle="devai" edition="free" />;
    }

    return null;
};
